import _throttle from 'lodash/throttle'

export const isVerticalScrollInTable = {
  data() {
    return {
      isVerticalScrollInTable: false,
      tableEl: null,
      resizeObserver: null
    }
  },

  methods: {
    checkHeightElementAndChangeIsVerticalScrollInTable: _throttle(function () {
      this.isVerticalScrollInTable =
        this.tableEl && this.tableEl.offsetWidth !== this.tableEl.clientWidth ? true : false
    }, 50)
  },

  mounted() {
    this.tableEl = document.querySelector('.is-vertical-scroll')
    this.tableEl && this.checkHeightElementAndChangeIsVerticalScrollInTable()
    this.resizeObserver = new ResizeObserver(this.checkHeightElementAndChangeIsVerticalScrollInTable)
    this.tableEl && this.resizeObserver.observe(this.tableEl)
  },

  destroyed() {
    this.tableEl && this.resizeObserver.unobserve(this.tableEl)
  }
}
